module.exports = __webpack_public_path__ + "static/img/s23.6b804e35.png";